export default __webpack_public_path__ + "static/media/logo.fe2475f3.png";